import request from 'src/api'
import { customerFunctions } from 'packs/customers/functions'
import moment from 'moment' // https://momentjs.com/
import { addToast } from 'src/toasts'
import { lockButton, unlockButton, hideModalKeepLoader } from 'src/lockButton'
import { handleErrors } from 'src/errors'
import { Tooltip } from 'bootstrap'
import { camelize } from 'src/misc'
import { openDownloadLink } from 'src/download'

window.initTooltips = function() {
  var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'))
  var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
    return new Tooltip(tooltipTriggerEl)
  })
}

window.eventDragDrop = function() {
  $('.quality-schedule-event.draggable').show(function(event) {
    $(this).draggable({
      revert: function(is_valid_drop) {
        return !is_valid_drop
      }
    })
  })

  $('.quality-schedule-month').show(function(event) {
    $(this).droppable({
      activeClass: 'active',
      hoverClass: 'hover',
      accept: function(elem) {
        const targetCustomer = $(this)[0].attributes.getNamedItem("data-customer").value
        const targetMonth = parseInt($(this)[0].attributes.getNamedItem("data-month").value)
        const customerId = elem[0].attributes.getNamedItem("data-customer").value
        const checkDate = moment(elem[0].attributes.getNamedItem("data-check-date").value)

        return targetCustomer === customerId && getQuarter(targetMonth) === getQuarter(checkDate.month() + 1) && targetMonth !== checkDate.month() + 1
      },
      drop: function (e, ui) {
        fullscreenLoader.show()

        const customerId = ui.draggable[0].attributes.getNamedItem("data-customer").value
        const eventId = ui.draggable[0].attributes.getNamedItem("data-event").value
        const targetMonth = parseInt($(this)[0].attributes.getNamedItem("data-month").value)
        const checkDate = moment(ui.draggable[0].attributes.getNamedItem("data-check-date").value)
        let newDate = moment(ui.draggable[0].attributes.getNamedItem("data-check-date").value)

        newDate.set('month', targetMonth - 1)
        if (targetMonth === 12) {
          newDate.set('year', checkDate.year() - 1)
        } else if (checkDate.month() === 11) {
          newDate.set('year', checkDate.year() + 1)
        }

        request.patch('/customers/' + customerId + '/quality_controls/' + eventId + '/update_date')
          .set('X-CSRF-Token', $('meta[name="csrf-token"]').attr('content'))
          .accept('json')
          .send({
            check_date: newDate.format('YYYY-MM-DD')
          })
          .then(res => {
            addToast(res.body.success, 'notice')

            $.getScript(getScheduleQuery()).fail(onScheduleQueryFail)

            fullscreenLoader.hide()
          })
          .catch(err => {
            handleErrors(err, null)
            $.getScript(getScheduleQuery()).fail(onScheduleQueryFail)
            fullscreenLoader.hide()
          })
      }
    })
  })
}

export default () => {
  customerFunctions()
  let timeoutHandle = null

  $('#select-qc-type').select2({
    minimumInputLength: -1,
    placeholder: I18n.t("selects.select_all"),
    width: '100%'
  })
  $('#select-qc-type').on('select2:opening select2:closing', function( event ) {
    var $searchfield = $(this).parent().find('.select2-search__field');
    $searchfield.prop('disabled', true);
  });

  // set dropdown values from local storage
  const qualityControlsIndexSelectEmpty = localStorage.getItem("qualityControlsIndexSelectEmpty")
  if (qualityControlsIndexSelectEmpty) {
    $("#select-empty").val(qualityControlsIndexSelectEmpty)
  }
  let qualityControlsIndexSelectQcType = localStorage.getItem("qualityControlsIndexSelectQcType")
  if (qualityControlsIndexSelectQcType) {
    if (['ALOITUS', 'SISÄINEN', 'SOITTO', 'ULKOINEN'].some(r=> qualityControlsIndexSelectQcType.split(',').includes(r))) {
      $("#select-qc-type").val(qualityControlsIndexSelectQcType.split(',')).trigger('change')
      $('#select-empty').closest('div').addClass('d-none')
    } else {
      qualityControlsIndexSelectQcType = ''
      $("#select-qc-type").val(qualityControlsIndexSelectQcType).trigger('change')
      localStorage.setItem("qualityControlsIndexSelectQcType", '')
      $('#select-empty').closest('div').removeClass('d-none')
    }
  }
  const qualityControlsIndexSelectYear = localStorage.getItem("qualityControlsIndexSelectYear")
  const qualityControlsIndexPreviousMonth = localStorage.getItem("qualityControlsIndexPreviousMonth")
  const qualityControlsIndexNextMonth = localStorage.getItem("qualityControlsIndexNextMonth")
  if (qualityControlsIndexSelectYear && qualityControlsIndexPreviousMonth && qualityControlsIndexNextMonth) {
    $("#select-year").val(qualityControlsIndexSelectYear)
    $('#previous-month').attr("data-date", qualityControlsIndexPreviousMonth)
    $('#next-month').attr("data-date", qualityControlsIndexNextMonth)
  }
  const qualityControlsIndexSelectBu = localStorage.getItem("qualityControlsIndexSelectBu")
  if (qualityControlsIndexSelectBu && qualityControlsIndexSelectBu !== '-1') {
    $("#select-bu").val(qualityControlsIndexSelectBu)
  }
  const qualityControlsIndexSelectDimension = localStorage.getItem("qualityControlsIndexSelectDimension")
  if (qualityControlsIndexSelectDimension) {
    $("#select-dimension").val(qualityControlsIndexSelectDimension)
  }
  const qualityControlsIndexSelectIncomeLocation = localStorage.getItem("qualityControlsIndexSelectIncomeLocation")
  if (qualityControlsIndexSelectIncomeLocation) {
    $("#select-income-location").val(qualityControlsIndexSelectIncomeLocation)
  }
  fullscreenLoader.show()
  $.getScript(getScheduleQuery()).fail(onScheduleQueryFail)

  // fullscreenLoader.show(), not lockButton: #offcanvasClose lives in the layout, so it survives the
  // whole Turbolinks page, and query_data.js.erb re-enables only the five #select-* controls — a
  // `disabled` here is permanent and kills the X. Before F-86 this called lockButton(event.target),
  // which hit the <span> inside the button and did nothing; switching to currentTarget made the
  // latent bug real. The loader is all this ever wanted, and it blocks a second click anyway.
  $('#offcanvasRight').on('click', '[data-bs-dismiss="offcanvas"]', function() {
    fullscreenLoader.show()
    $.getScript(getScheduleQuery()).fail(onScheduleQueryFail)
  })

  $('#select-qc-type, #select-bu, #select-empty, #select-dimension').change(function(event) {
    lockButton(event.currentTarget)
    localStorage.setItem(camelize('quality-controls-index-' + $(this).attr('id')), $(this).val())
    if ($('#select-qc-type').val().length === 0) {
      $('#select-empty').closest('div').removeClass('d-none')
    } else {
      $('#select-empty').closest('div').addClass('d-none')
    }
    $.getScript(getScheduleQuery()).fail(onScheduleQueryFail)
  })

  $('#select-year').change(function() {
    const year = $('#select-year').val()
    localStorage.setItem('qualityControlsIndexSelectYear', year)

    if (year) {
      lockButton(this)
      $('#previous-month').attr("data-date", year + '-05-01')
      $('#next-month').attr("data-date", year + '-07-01')
      localStorage.setItem('qualityControlsIndexPreviousMonth', year + '-05-01')
      localStorage.setItem('qualityControlsIndexNextMonth', year + '-07-01')

      let query = getScheduleQuery()
      if (query.split('/quality_controls/query_data')[1].length > 0) {
        query += '&year=' + year
      } else {
        query += '?year=' + year
      }

      $.getScript(query).fail(onScheduleQueryFail)
    }
  })

  $('ul.pagination li').on('click', function(event) {
    lockButton(event.currentTarget)

    $('#select-year').val('').change()

    const date = $(this)[0].attributes.getNamedItem("data-date").value
    const prev = moment(date).subtract(1, 'months').format('YYYY-MM-DD')
    const next = moment(date).add(1, 'months').format('YYYY-MM-DD')
    $('#previous-month').attr("data-date", prev)
    $('#next-month').attr("data-date", next)
    localStorage.setItem('qualityControlsIndexPreviousMonth', prev)
    localStorage.setItem('qualityControlsIndexNextMonth', next)

    $.getScript(getScheduleQuery() + '&date=' + date).fail(onScheduleQueryFail)
  })

  $('#search-name').on('input', function(event) {
    if ($('#search-name').val()) {
      $('.clear-button').removeClass('d-none')
    } else {
      $('.clear-button').addClass('d-none')
    }

    window.clearTimeout(timeoutHandle)
    timeoutHandle = window.setTimeout(function() {
      $.getScript(getScheduleQuery()).fail(onScheduleQueryFail)
    }, 400)
  })

  // Same as the offcanvas close above: nothing re-enables .clear-button, so disabling it once would
  // break clearing the search for the rest of the session (F-86 follow-up).
  $('.clear-button').on('click', function() {
    fullscreenLoader.show()
    $('#search-name').val('')
    $('.clear-button').addClass('d-none')
    $.getScript(getScheduleQuery()).fail(onScheduleQueryFail)
  })

  $('#quality-schedule-table').on('click', '.quality-schedule-add-event', function(event) {
    lockButton(event.currentTarget)

    const customerId = $(this)[0].attributes.getNamedItem("data-customer").value
    const date = $(this)[0].attributes.getNamedItem("data-date").value
    
    request.post('customers/' + customerId + '/quality_controls/calendar_event')
      .set('X-CSRF-Token', $('meta[name="csrf-token"]').attr('content'))
      .accept('json')
      .send({
        quality_control: {
          check_date: date,
          qc_type: ($('#select-qc-type').val().length === 0 ? 'ULKOINEN' : $('#select-qc-type').val()[0])
        }
      })
      .then(res => {
        addToast(res.body.success, 'notice')
        $.getScript(getScheduleQuery())

        unlockButton(event.currentTarget)
      })
      .catch(err => {
        handleErrors(err, event.currentTarget)
      })
  })

  $('#quality-schedule-table').on('click', '.quality-schedule-event', function(event) {
    lockButton(event.currentTarget)
    
    const customerId = $(this)[0].attributes.getNamedItem("data-customer").value
    const eventId = $(this)[0].attributes.getNamedItem("data-event").value

    $.getScript('/customers/' + customerId + '/quality_controls/' + eventId + '/edit')
    offcanvasRight.show()
  })

  eventDragDrop()
  initTooltips()

  $('#customers, #contact_people').on('click', async function(event) {
    const btn = event.currentTarget
    lockButton(btn)
    fullscreenLoader.show()

    let business_unit = $('#select-bu').length ? $('#select-bu').val() : '-1'
    let dimension = $('#select-dimension').val()
    const action = this.id === 'contact_people' ? 'contact_people_list' : 'customers_list'
    let query = '/customers/' + action + '?bu=' + business_unit + '&status=ASIAKAS&dimension=' + dimension
    const searchName = $('#search-name').val()
    if (searchName) query += '&query=' + searchName

    try {
      const res = await request.get(query)
        .set('X-CSRF-Token', $('meta[name="csrf-token"]').attr('content'))
        .accept('json')
      await waitForJob(res.body.job_id, { intervalMs: 1000, timeoutMs: 120000 })
      const jobRes = await request.get(`/background_jobs/${res.body.job_id}`)
        .set('X-CSRF-Token', $('meta[name="csrf-token"]').attr('content'))
        .accept('json')
      if (jobRes.body.file_url) {
        openDownloadLink(jobRes.body.file_url, { newTab: jobRes.body.open_in_tab })
        addToast(I18n.t('download.ready'), 'notice')
      }
    } catch (err) {
      handleErrors(err, btn)
    } finally {
      fullscreenLoader.hide()
      unlockButton(btn)
    }
  })

  $('#deviations').on('click', function(event) {
    lockButton(event.currentTarget)
    $.getScript('/quality_controls/deviations').always(() => unlockButton(event.currentTarget))
  })

  $('#download').on('click', function(event) {
    lockButton(event.currentTarget)
    $.getScript('/quality_controls/download_format').always(() => unlockButton(event.currentTarget))
  })

  $('#mainModal').on('click', '#confirmDownload', async function(event) {
    const btn = event.currentTarget
    const format = $('#download-format').val()
    const queryString = getScheduleQuery().split('/quality_controls/query_data')[1]
    lockButton(btn)
    hideModalKeepLoader()
    const sep = queryString.length > 0 ? '&' : '?'
    const param = format === 'pdf' ? 'download=pdf' : 'download=true'
    const url = '/quality_controls/download_quality_data' + queryString + sep + param

    try {
      const res = await request.get(url)
        .set('X-CSRF-Token', $('meta[name="csrf-token"]').attr('content'))
        .accept('json')
      await waitForJob(res.body.job_id, { intervalMs: 1000, timeoutMs: 120000 })
      const jobRes = await request.get(`/background_jobs/${res.body.job_id}`)
        .set('X-CSRF-Token', $('meta[name="csrf-token"]').attr('content'))
        .accept('json')
      if (jobRes.body.file_url) {
        openDownloadLink(jobRes.body.file_url, { newTab: jobRes.body.open_in_tab })
        addToast(I18n.t('download.ready'), 'notice')
      }
    } catch (err) {
      handleErrors(err, btn)
    } finally {
      fullscreenLoader.hide()
      unlockButton(btn)
    }
  })

  $('#mainModal').on('change', '#deviations-select-bu', function(event) {
    if (($(this).val().includes('-1') && $(this).data('val').toString() !== ['-1'].toString()) || $(this).val().length === 0) {
      $(this).data('val', '-1')
      $(this).val('-1').trigger('change')
    } else if ($(this).data('val').includes('-1') && $(this).val().length > 1) {
      let newVal = $(this).val()
      newVal.shift()
      $(this).data('val', newVal)
      $(this).val(newVal).trigger('change')
    }
  })


  $('#mainModal').on('click', '#downloadDeviations', async function(event) {
    $('#mainModal .errors').remove()
    $('#mainModal .is-invalid').removeClass('is-invalid')
    let valid = true
    if ($('#deviations-select-quarter').val().length === 0) {
      $('#deviations-select-quarter').addClass('is-invalid')
      $('#deviations-select-quarter').parent().find('.select2-selection').addClass('is-invalid')
      $('#deviations-select-quarter').parent().find('.select2').after('<div class="errors">' + I18n.t("errors.not_empty") + '</div>')
      valid = false
    }
    if ($('#deviations-limit').val().length === 0) {
      $('#deviations-limit').addClass('is-invalid')
      $('#deviations-limit').after('<div class="errors">' + I18n.t("errors.not_empty") + '</div>')
      valid = false
    }
    if (valid) {
      const btn = event.currentTarget
      const business_unit_id = $('#deviations-select-bu').val()
      const quarter = $('#deviations-select-quarter').val()
      const dimension = $('#select-dimension').val()
      const type = $('#deviations-select-type').val()
      const limit = $('#deviations-limit').val()
      const url = '/quality_controls/download_deviations?business_unit_id=' + business_unit_id + '&quarter=' + quarter + '&dimension=' + dimension + '&type=' + type + '&limit=' + limit

      lockButton(btn)
      hideModalKeepLoader()

      try {
        const res = await request.get(url)
          .set('X-CSRF-Token', $('meta[name="csrf-token"]').attr('content'))
          .accept('json')
        await waitForJob(res.body.job_id, { intervalMs: 1000, timeoutMs: 120000 })
        const jobRes = await request.get(`/background_jobs/${res.body.job_id}`)
          .set('X-CSRF-Token', $('meta[name="csrf-token"]').attr('content'))
          .accept('json')
        if (jobRes.body.file_url) {
          openDownloadLink(jobRes.body.file_url, { newTab: jobRes.body.open_in_tab })
          addToast(I18n.t('download.ready'), 'notice')
        }
      } catch (err) {
        handleErrors(err, btn)
      } finally {
        fullscreenLoader.hide()
        unlockButton(btn)
      }
    }
  })
}

function getQuarter(month) {
  if (month >= 6 && month <= 8) {
    return 1
  } else if (month >= 9 && month <= 11) {
    return 2
  } else if (month === 12 || month <= 2) {
    return 3
  } else {
    return 4
  }
}

function onScheduleQueryFail() {
  $('#select-qc-type, #select-bu, #select-dimension, #select-empty, #select-year').prop("disabled", false)
  fullscreenLoader.hide()
  addToast(I18n.t("errors.unexpected_error"), 'error')
}

function getScheduleQuery() {
  let query = ''

  const type = $('#select-qc-type').val()
  if (type.length > 0) {
    query += '?qc_type=' + type
  }

  if ($('#select-empty').is(":visible")) {
    if (query.length > 0) {
      query += '&'
    } else {
      query += '?'
    }
    query += 'empty=' + $('#select-empty').val()
  }

  const bu = $('#select-bu').val()
  if (bu) {
    if (query.length > 0) {
      query += '&'
    } else {
      query += '?'
    }
    query += 'bu=' + bu
  }

  const dimension = $('#select-dimension').val()
  if (dimension) {
    if (query.length > 0) {
      query += '&'
    } else {
      query += '?'
    }
    query += 'dimension=' + dimension
  }

  const income_location = $('#select-income-location').val()
  if (income_location) {
    if (query.length > 0) {
      query += '&'
    } else {
      query += '?'
    }
    query += 'income_location=' + income_location
  }

  if ($('#previous-month').length) {
    if (query.length > 0) {
      query += '&'
    } else {
      query += '?'
    }
    const date = moment($('#previous-month').attr("data-date")).add(1, 'months').format('YYYY-MM-DD')
    query += 'date=' + date
  }

  const searchName = $('#search-name').val()
  if (searchName) {
    if (query.length > 0) {
      query += '&'
    } else {
      query += '?'
    }
    query += 'search_name=' + searchName
  }

  return '/quality_controls/query_data' + query
}
